<script setup lang="ts">
import { formatDateTime } from '@/services/functions';
import i18n from '@/lang/i18n';

const props = defineProps<{
  combineItems: {
    driverName: string;
    start: Date | string;
    end: Date | string;
  }
}>();

function changeFormat(dateTime: Date | string) {
  return typeof dateTime === 'string' ? formatDateTime(new Date(dateTime)) : formatDateTime(dateTime);
}
</script>
<template>
  <div class="w-100 my-6">
    <div class="w-100 d-flex">
      <h4 class="mx-auto mt-0 mb-4">
        {{ i18n.global.t('pages.dailyReports.combineForm.registerModal.message') }}
      </h4>
    </div>
    <div class="w-50 d-flex mx-auto cols-12 mt-2">
      <div class="w-75 cols-5">
        <div class="text-title-large font-weight-bold">
          {{ i18n.global.t('pages.dailyReports.combineForm.registerModal.afterDeliveryPlans') }}
        </div>
      </div>
      <div class="w-100 d-flex cols-7">
      </div>
    </div>
    <div class="w-50 d-flex mx-auto cols-12 mt-2">
      <div class="w-75 cols-5">
        <div class="text-label-large font-weight-bold">
          {{ i18n.global.t('pages.dailyReports.combineForm.registerModal.driver') }}
        </div>
      </div>
      <div class="w-100 d-flex cols-7">
        {{ props.combineItems.driverName }}
      </div>
    </div>
    <div class="w-50 d-flex mx-auto cols-12 mt-2">
      <div class="w-75 cols-5">
        <div class="text-label-large font-weight-bold">
          {{ i18n.global.t('pages.dailyReports.combineForm.registerModal.leavingWarehouse') }}
        </div>
      </div>
      <div class="w-100 d-flex cols-7">
        {{ changeFormat(props.combineItems.start) }}
      </div>
    </div>
    <div class="w-50 d-flex mx-auto cols-12 mt-2">
      <div class="w-75 cols-5">
        <div class="text-label-large font-weight-bold">
          {{ i18n.global.t('pages.dailyReports.combineForm.registerModal.returningWarehouse') }}
        </div>
      </div>
      <div class="w-100 d-flex cols-7">
        {{ changeFormat(props.combineItems.end) }}
      </div>
    </div>
  </div>
</template>
<style scoped>
.text-title-large {
  font-size: 17px;
}
.text-label-large {
  font-size: 15px;
}
</style>
